/* eslint-disable */
export default {
  logging: 'Connexion…',
  logCall: 'Journal des appels',
  editLog: 'Modifier le journal',
  select: 'Sélectionner un enregistrement correspondant',
  OnHold: 'En attente',
  Ringing: 'Sonnerie en cours',
  CallConnected: 'Appel connecté',
  unknownUser: 'Utilisateur inconnu',
  unknownNumber: 'Anonyme',
  unavailable: 'Non disponible',
  viewDetails: 'Afficher les renseignements',
  addEntity: 'Créer',
  addLog: 'Liste',
  text: 'Texto',
  call: 'Appeler',
  missedCall: 'Manqué',
  inboundCall: 'Entrant',
  outboundCall: 'Sortant',
  answeredBy: 'Répondu par',
} as const;

// @key: @#@"logging"@#@ @source: @#@"Logging..."@#@
// @key: @#@"logCall"@#@ @source: @#@"Log Call"@#@
// @key: @#@"editLog"@#@ @source: @#@"Edit Log"@#@
// @key: @#@"select"@#@ @source: @#@"Select a matching record"@#@
// @key: @#@"OnHold"@#@ @source: @#@"On Hold"@#@
// @key: @#@"Ringing"@#@ @source: @#@"Ringing"@#@
// @key: @#@"CallConnected"@#@ @source: @#@"Call Connected"@#@
// @key: @#@"unknownUser"@#@ @source: @#@"Unknown User"@#@
// @key: @#@"unknownNumber"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"unavailable"@#@ @source: @#@"Unavailable"@#@
// @key: @#@"viewDetails"@#@ @source: @#@"View Details"@#@
// @key: @#@"addEntity"@#@ @source: @#@"Create New"@#@
// @key: @#@"addLog"@#@ @source: @#@"Log"@#@
// @key: @#@"text"@#@ @source: @#@"Text"@#@
// @key: @#@"call"@#@ @source: @#@"Call"@#@
// @key: @#@"missedCall"@#@ @source: @#@"Missed"@#@
// @key: @#@"inboundCall"@#@ @source: @#@"Inbound"@#@
// @key: @#@"outboundCall"@#@ @source: @#@"Outbound"@#@
// @key: @#@"answeredBy"@#@ @source: @#@"Answered by"@#@
